import environment from '../config/environment.json';
import { PLATFORM } from 'aurelia-pal';
import { AuthService } from 'pages/login/service';

import 'node-waves/dist/waves';
import 'node-waves/dist/waves.css';

export function configure(aurelia) {
    aurelia.use
        .standardConfiguration()
        .feature(PLATFORM.moduleName('resources/index'))
        .plugin(PLATFORM.moduleName('aurelia-validation'))
        .plugin(PLATFORM.moduleName('aurelia-dialog'), config => {
            config.useDefaults();
            config.settings.lock = true;
            config.settings.startingZIndex = 2000;
        });

    aurelia.use.developmentLogging(environment.debug ? 'debug' : 'warn');

    if (environment.testing) {
        aurelia.use.plugin(PLATFORM.moduleName('aurelia-testing'));
    }

    const authService = aurelia.container.get(AuthService);

    aurelia.start().then(() => {
        if (authService.isAuthenticated()) {
            aurelia.setRoot(PLATFORM.moduleName('roots/app/index'))
        } else {
            aurelia.setRoot(PLATFORM.moduleName('roots/auth/index'))
        }
    });
}
